import React, { Component } from 'react';
import { connect } from 'react-redux';

class Price extends Component {

  constructor(props){
    super(props);
  }

  render() {

    const { currency, price, selectedCurrency, currencyList, withoutSign } = this.props;


    let value = parseFloat(price);
      if (currency) {
          let rate;
            if (selectedCurrency.id != currency) {
                currencyList.forEach(function(convertCurrency){
                    if (convertCurrency.id == currency) {
                        rate = convertCurrency.rates[selectedCurrency.id];
                    }
                });

                value = price * (rate.nominal / rate.rate)
            }
      }


      value = parseInt(value);
      if (typeof Intl != 'undefined') {
          value = new Intl.NumberFormat('ru-RU').format(value);
      }

      let sign = '';
      if (!withoutSign) {
          if (selectedCurrency.id=='RUR') {
              sign = <span className="sign">i</span>;
          } else {
              sign = selectedCurrency.sign;
          }
      }


    return (
        <span>

            {!!value &&
                (value + ' ')
            }
            {sign}

       </span>
    );
  }
}



function mapStateToProps (state) {
  return {
      selectedCurrency: state.user.currency,
      currencyList: state.user.currencyList
  }
}


export default connect(mapStateToProps)(Price)




// WEBPACK FOOTER //
// ./src/common/components/layout/Price.js